import { render } from "./clientCreate.vue?vue&type=template&id=77bdfa3c&scoped=true"
import script from "./clientCreate.vue?vue&type=script&lang=js"
export * from "./clientCreate.vue?vue&type=script&lang=js"

import "./clientCreate.vue?vue&type=style&index=0&id=77bdfa3c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bdfa3c"]])

export default __exports__